module.exports = __webpack_public_path__ + "img/mon-2.f5250536.png";